import React from 'react';
import { useTranslation } from 'react-i18next';

import { SAVING_IMAGES } from '../../Data';
import { Container, Content1, Content2, StyledImage, Text1, Text2, TextContainer } from './styled';

interface Props {
    itemsCount: number;
    savedCo2: number;
    score: number;
}

const ResultWidget = (props: Props) => {
    const { itemsCount, savedCo2, score } = props;

    const { t } = useTranslation();

    const image = SAVING_IMAGES[score] ?? SAVING_IMAGES[0];

    return (
        <Container>
            <Content1 variant='outlined'>
                <Content2>
                    <StyledImage src={image} alt='CO2 saving icon' />
                    <TextContainer>
                        <Text1 variant='h5'>
                            {t('pages.co2_external_tool.result', { count: itemsCount })}
                        </Text1>
                        <Text2 variant='h5'>
                            {isNaN(savedCo2) ? '-' : savedCo2.toFixed(2)} kg
                        </Text2>
                    </TextContainer>
                </Content2>
            </Content1>
        </Container>
    );
};

export default ResultWidget;